define('home/mixins/withOnboarding',[
    'underscore',

    'home/models/Session',
    'home/utils/navigationUtils',
], function (
    _,

    Session,
    navigationUtils
) {
    'use strict';

    var NUM_STEPS = 3;
    var ONBOARDING_ROUTE_PATHS = ['explore', 'exploreChannel', 'exploreDiscussions'];

    /**
     * Mixes in helper functions to determine if/where user is in the
     * onboarding process.
     *
     * Can be applied to any Backbone object (Model, View, Collection).
     */
    var onboardingMixinWrapper = function () {
        var _stepNumber;
        return {
            events: {
                'click [data-action=skip-onboarding]': 'completeOnboarding',
            },

            initialize: function (_initialize) {
                _initialize.apply(this, _.rest(arguments));

                var session = Session.get();
                session.loadPromise().then(_.bind(function () {
                    var forumsFollowing = session.getUserProfile().forumsFollowing;
                    this.listenTo(forumsFollowing.items, 'add remove reset', this.updateStepNumber);
                    this.updateStepNumber();
                }, this));
            },

            getStepNumber: function () {
                return _stepNumber;
            },

            isInOnboarding: function (app, session) {
                return session.isLoggedIn() &&
                    session.user.shouldHomeOnboard() &&
                    _.contains(ONBOARDING_ROUTE_PATHS, app.getCurrentRouteName());
            },

            userCanSkip: function () {
                var session = Session.get();
                return session.isLoggedIn() && !session.user.registeredThisWeek();
            },

            updateStepNumber: function () {
                // Each "step" is the following of a channel (not forum).
                // Must follow some number in order to complete all "steps"
                // of onboarding.
                var channelsFollowing = this.getChannelsFollowing();
                var numChannelsFollowing = channelsFollowing.length || 0;

                var newStepNumber = Math.min(numChannelsFollowing, NUM_STEPS) + 1;

                var changed = newStepNumber !== _stepNumber;
                _stepNumber = newStepNumber;
                if (changed)
                    this.trigger('change:stepNumber');
            },

            getChannelsFollowing: function () {
                var forumsFollowing = Session.get().getUserProfile().forumsFollowing;
                return forumsFollowing.items.filter(function (forum) {
                    return forum.channel;
                });
            },

            completeOnboarding: function (evt) {
                if (evt)
                    evt.preventDefault();

                var user = Session.get().user;
                user.setHomeOnboardComplete(true);
                navigationUtils.navigate('/home/', { trigger: true });
            },
        };
    };

    return function withOnboarding() {
        var onboardingMixin = onboardingMixinWrapper();

        this.constructor.NUM_STEPS = NUM_STEPS;

        this.initialize = _.wrap(this.initialize, onboardingMixin.initialize);

        this.events = _.extend(onboardingMixin.events, this.events);

        _.extend(this, _.pick(onboardingMixin, [
            'getStepNumber',
            'isInOnboarding',
            'userCanSkip',
            'updateStepNumber',
            'getChannelsFollowing',
            'completeOnboarding',
        ]));
    };
});

